import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "24px 40px",
    minHeight: "calc(100vh - 200px)",
    display: "flex",
    justifyContent: "center",
  },
  content: {
    maxWidth: 600,
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 32,
    fontSize: 24,
    fontWeight: 600,
    color: "#333",
    "& svg": {
      marginRight: 12,
      fontSize: 28,
    },
  },
  card: {
    padding: 32,
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  productImage: {
    width: "100%",
    height: 240,
    objectFit: "contain",
    objectPosition: "center center",
    borderRadius: 8,
    marginBottom: 24,
  },
  productTitle: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 16,
    color: "#333",
  },
  productDescription: {
    fontSize: 16,
    color: "#666",
    marginBottom: 24,
    lineHeight: 1.6,
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px solid #e0e0e0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  infoLabel: {
    fontSize: 16,
    color: "#666",
  },
  infoValue: {
    fontSize: 16,
    fontWeight: 600,
    color: "#333",
  },
  priceRow: {
    marginTop: 24,
    paddingTop: 24,
    borderTop: "2px solid #e0e0e0",
  },
  totalLabel: {
    fontSize: 18,
    fontWeight: 600,
    color: "#333",
  },
  totalPrice: {
    fontSize: 28,
    fontWeight: 700,
    color: "#00897b",
  },
  buttonContainer: {
    display: "flex",
    gap: 16,
    marginTop: 32,
  },
  button: {
    flex: 1,
    height: 48,
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 8,
  },
  backButton: {
    backgroundColor: "#f5f5f5",
    color: "#333",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  paymentButton: {
    backgroundColor: "#00897b",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#00796b",
    },
  },
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 400,
  },
  emptyText: {
    fontSize: 16,
    color: "#666",
    marginBottom: 24,
  },
  dialogPaper: {
    borderRadius: 12,
    padding: "8px 8px 16px 8px",
    minWidth: 380,
    maxWidth: 480,
  },
  dialogTitle: {
    padding: "16px 24px 8px 24px",
    "& h2": {
      fontSize: 20,
      fontWeight: 600,
      color: "#222",
    },
  },
  dialogContent: {
    padding: "8px 24px 16px 24px",
  },
  dialogText: {
    fontSize: 16,
    color: "#444",
    lineHeight: 1.6,
    margin: 0,
  },
  highlightPackage: {
    fontWeight: 600,
    color: "#222",
  },
  highlightUsername: {
    fontWeight: 700,
    color: "#00897b",
    backgroundColor: "#e0f2f1",
    padding: "2px 8px",
    borderRadius: 4,
    display: "inline-block",
    wordBreak: "break-word",
  },
  dialogActions: {
    padding: "8px 24px 8px 24px",
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
  },
  dialogButton: {
    minWidth: 84,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    borderRadius: 6,
  },
  dialogNoButton: {
    backgroundColor: "#f5f5f5",
    color: "#333",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  dialogYesButton: {
    backgroundColor: "#00897b",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#00796b",
    },
  },
}));
